import React, { useState, useCallback } from "react";
import { Menu } from "lucide-react";

import TeacherDashboardSidebar from "./Components/Sidebar";
import TeacherCourses from "./Components/TeacherCourses";
import TeacherCreateMeeting from "./Components/TeacherCreateMeeting";
import TeacherDashboard2 from "./Components/TeacherDashboard2/TeacherDashboard2.jsx";
import TeacherAnalyticsDashboard from "./TeacherAnalyticsDashboard.jsx";
import TeacherProfilePage from "./Components/TeacherProfile/TeacherProfilePage";
import AccountSettings from "./Components/TeacherProfile/TeacherAccountSettings";
import CourseManagement from "../course/teacher/CourseManagement";
import { useUtilityContext } from "../../context/UtilityContext.js";

const TeacherDashboard = () => {
  const { activeSection, setActiveSection, setSelectedCourseId, setActiveCourseTab } = useUtilityContext();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-fit min-h-screen dark:bg-gray-900 dark:text-white relative">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsMobileMenuOpen(true)}
        className="fixed top-3 left-3 sm:top-4 sm:left-4 z-30 lg:hidden p-2 rounded-sm bg-white dark:bg-gray-800 shadow-md border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5 sm:h-6 sm:w-6 text-gray-700 dark:text-gray-300" />
      </button>

      {/* Sidebar */}
      <TeacherDashboardSidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        isMobileOpen={isMobileMenuOpen}
        setIsMobileOpen={setIsMobileMenuOpen}
      />

      {/* Main Content */}
      <div className="w-full lg:flex-1 lg:ml-0 max-h-screen overflow-y-auto overflow-x-hidden">
        {activeSection === "Dashboard" && <TeacherDashboard2 />}
        {activeSection === "myCourses" && <TeacherCourses />}
        {activeSection === "Courseware" && <CourseManagement />}
        {activeSection === "NewMeetings" && <TeacherCreateMeeting />}
        {activeSection === "Analytics" && <TeacherAnalyticsDashboard />}
        {activeSection === "Profile" && <TeacherProfilePage />}
        {activeSection === "Account" && <AccountSettings />}
      </div>
    </div>
  );
};

export default TeacherDashboard;
